export default "__VITE_ASSET__CojtNnhP__"